<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
<!--    <Title :title="route"></Title>-->
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;" shadow="never">
      <el-form :model="detail" label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>
        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        <el-divider content-position="left">协同信息</el-divider>
        <el-form-item prop="user" label-width="150px" label="协同人员">
          <div v-for="(item, index) in detail.people" :key="index" class="people">
            <div>{{item.deptName}}/{{item.realName}}</div>
          </div>
        </el-form-item>
        <el-form-item prop="workTimes" label-width="150px" label="协同时间">
          <el-date-picker
            readonly
            v-model="detail.worktimes"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="coworkingSubject" label-width="150px" label="协同事由">
          {{detail.coworkingSubject}}
        </el-form-item>
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit===true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input
              type="textarea" rows="5"
              maxlength="500" show-word-limit
              v-model="ruleForm.auditOpinion">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <Setp :nodes="nodes" :audits="audits"></Setp>
  </div>
</template>

<script>
import Title from "../../Title";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
export default {
  name: "CoworkingDetail",
  components: {Title, Setp, AuditList},
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name:'协同办公申请',
        path: ''
      },
      user: {},
      param: {},
      nodes: [],
      audits: [],
      auditHistory: [],
      allowAudit: false,
      detail: {
        people: []
      },
      ruleForm: {
        auditOpinion: "",
      },
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.param = {
      applyId: this.query.applyId,
      applyServiceId: this.query.applyServiceId,
      applyType: this.query.applyType
    }
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({applyId: this.param.applyId}).then(res => {
        if (res.code === 200) {
          this.allowAudit = res.object === 1
        }
      })
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        if (res.object) {
          this.detail = res.object.detail
          let arr = []
          arr[0] = this.detail.startTime
          arr[1] = this.detail.endTime
          this.detail.worktimes = arr
          this.audits = res.object.audits
          this.auditHistory = res.object.auditHistory
          this.user = res.object.user
          this.nodes = res.object.nodes
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async audit(isAgree) {
      this.allowAudit = false
      let param = this.param
      param.auditOpinion = isAgree === 2 ? "同意" : "不同意"
      if (this.ruleForm.auditOpinion) {
        param.auditOpinion = this.ruleForm.auditOpinion
      }
      param.isAgree = isAgree
      const res = await requestAudit(param)
      if (res.code === 200) {
        this.getAuditShow()
        await this.getObject()
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    }
  }
}
</script>

<style>
.people {
  display: inline;
}
</style>